import styled from 'styled-components'

import { Modal } from '@sketch/components'

export const StyledModal = styled(Modal)`
  & ${Modal.Body} {
    &:first-child {
      margin-top: 0;
    }
  }
`
